import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, Col, Card, Modal, Row } from 'react-bootstrap';
import AppContext from 'context/Context';
import PredictedCostChart from './PredictedCostChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const PredictedCostModal = ({
  showPredictedCost,
  predictedCost,
  handleCloseForPredictedCost,
  handleConfirm,
  handleReSchedule
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  return (
    <Modal
      show={showPredictedCost}
      onHide={handleCloseForPredictedCost}
      contentClassName="border"
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="bg-light px-card border-bottom-0"
      >
        <Modal.Title as="h5">
          Total Estimated Cost: £{predictedCost?.total_cost.toFixed(2)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-card">
        <Card className="mb-4">
          <PredictedCostChart
            efficiencyScore={predictedCost?.efficiency_score}
          />
        </Card>

        <Row className="align-items-center">
          <Col xs="auto">
            <b>AI Insight:</b>
          </Col>
          <Col xs="auto">{predictedCost?.ai_insight}</Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="auto">
            <b>Suggestion:</b>
          </Col>
          <Col xs="auto">{predictedCost?.suggestion}</Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="bg-light px-card border-top-0">
        <Button
          variant="primary"
          type="button"
          onClick={handleConfirm}
          className="px-4 mx-0"
        >
          Confirm Meeting
        </Button>
        <Button
          variant="success"
          type="button"
          onClick={handleReSchedule}
          className="px-4 mx-2"
        >
          Re-Schedule
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PredictedCostModal;
